var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amap-location",class:{'hidden-geo': _vm.hiddenGeo},on:{"click":_vm.handleClick}},[_c('div',{style:(_vm.style),attrs:{"id":`amap-location-${_vm.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }